import { SetStateAction, useEffect, useState } from 'react';
import AppConfig from '../AppConfig';
import {
  JWTPayload,
  getToken,
  verifyTokenAndInit,
  decodeAuthToken,
} from '../utils/tokenUtils';
import { EMessageType, IMessagePayload } from '../types';
import safeJsonParse from '../utils/safeJsonParse';
import { postMessageToParent } from '../utils/messageUtils';

export interface IAuthResult {
  isTokenAdded: boolean;
  user: null | JWTPayload;
  isAppReady: boolean;
  setUser: React.Dispatch<SetStateAction<JWTPayload | null>>;
  setIsTokenAdded: React.Dispatch<SetStateAction<boolean>>;
  token: string | null;
}

const useAuth = (): IAuthResult => {
  const [token, setToken] = useState<string | null>(() => {
    return getToken();
  });
  const [user, setUser] = useState<JWTPayload | null>(() => {
    if (token) {
      const decodedPayload = decodeAuthToken(token);
      return decodedPayload;
    }
    return null;
  });

  const [isTokenAdded, setIsTokenAdded] = useState<boolean>(() => {
    return user ? true : false;
  });
  useEffect(() => {
    const handleEvent = async () => {
      const tokenFromCookies = getToken();
      const decodedPayload = decodeAuthToken(tokenFromCookies as string);
      setUser(decodedPayload);
      setToken(tokenFromCookies);
      setIsTokenAdded(true);
      window?.NativeBridge?.onLoadComplete?.();
    };

    window.addEventListener(
      AppConfig.TOKEN_ADDED_VIA_EXTERNAL_APPLICATION_EVENT as string,
      handleEvent
    );

    const messageListener = (event: MessageEvent) => {
      const { data: message } = event;
      window.dev.i('received message', message);

      // if (import.meta.env.PROD && origin === AppConfig.PLUM_APP_HOST_URL) {
        const payload = safeJsonParse(message) as IMessagePayload;

        if (payload == null) {
          return;
        }

        if (payload?.type === EMessageType.TOKEN) {
          window.dev.i('3. AUTH_TRANSFER: RECEIVED TOKEN', message);
          verifyTokenAndInit(String(payload?.data));
        }
      // }
    };

    window.addEventListener('message', messageListener);

    // send ready message to parent for TOKEN
    if (window.parent) {
      window.dev.i('1. AUTH_TRANSFER: ADDED MESSAGE EVENT IN CHAT_UI');
      postMessageToParent(EMessageType.READY, [EMessageType.TOKEN]);
    }

    return () => {
      window.removeEventListener(
        AppConfig.TOKEN_ADDED_VIA_EXTERNAL_APPLICATION_EVENT as string,
        handleEvent
      );

      window.removeEventListener('message', messageListener);
    };
  }, [isTokenAdded, token]);

  return {
    isTokenAdded,
    user,
    setUser,
    setIsTokenAdded,
    isAppReady: isTokenAdded,
    token,
  };
};

export default useAuth;
